import { render, staticRenderFns } from "./refundOrderInfo.vue?vue&type=template&id=a45c2ada&scoped=true&"
import script from "./refundOrderInfo.vue?vue&type=script&lang=js&"
export * from "./refundOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./refundOrderInfo.vue?vue&type=style&index=0&id=a45c2ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45c2ada",
  null
  
)

export default component.exports